import React from 'react';
import {
  resolveDatasetImportJobProgressMetrics,
  type DatasetImportJobProgressVariant,
} from '../../utils/datasetImportJob';
import '../training/FineTuningJobProgress.css';

export interface DatasetImportJobProgressProps {
  status?: string | null;
  phase?: string | null;
  progressPercent?: number | null;
  /** Smoothed display value from polling. Takes precedence over progressPercent. */
  displayPercent?: number | null;
  compact?: boolean;
  className?: string;
}

const VARIANT_CLASS: Record<DatasetImportJobProgressVariant, string> = {
  running: 'ft-job-progress__fill--running',
  completed: 'ft-job-progress__fill--completed',
  failed: 'ft-job-progress__fill--failed',
};

const DatasetImportJobProgress: React.FC<DatasetImportJobProgressProps> = ({
  status,
  phase,
  progressPercent,
  displayPercent,
  compact = false,
  className = '',
}) => {
  const metrics = resolveDatasetImportJobProgressMetrics(status, phase, progressPercent, displayPercent);
  if (!metrics.show) return null;

  const widthPercent = metrics.percent > 0 ? Math.max(metrics.percent, 2) : 0;

  return (
    <div
      className={['ft-job-progress', compact ? 'ft-job-progress--compact' : '', className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="ft-job-progress__head">
        <span className="ft-job-progress__title">Progress</span>
        <span className="ft-job-progress__percent">{Math.round(metrics.percent)}%</span>
      </div>
      <div
        className="ft-job-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(metrics.percent)}
        aria-label={`Dataset import progress ${Math.round(metrics.percent)} percent`}
      >
        <div
          className={`ft-job-progress__fill ${VARIANT_CLASS[metrics.variant]}`}
          style={{ width: `${widthPercent}%` }}
        />
      </div>
      {metrics.label ? <div className="ft-job-progress__label">{metrics.label}</div> : null}
    </div>
  );
};

export default DatasetImportJobProgress;
